<template>
<div class="sidebar">
    <ul class="menu">
        <li v-for="item in menuItems" :key="item.id" class="menu-item">
            <div class="menu-header" @click.stop="toggleMenu(item)" :class="item.id == currentId && !item.isMore?'menuChecked':''">
                <span>{{ item.name }}</span>
                <i :class="item.isOpen?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
            <ul v-show="item.isOpen">
                <li v-for="child in item.children" :key="child.id" class="submenu-item" :class="!child.isMore && child.id != currentId?'menuHover':''">
                    <div class="submenu-header" @click.stop="toggleMenu(child)" @click="toPage(child)" :class="child.id == currentId && !child.isMore?'menuChecked':''">
                        <span>{{ child.name }}</span>
                        <i v-if="child.isMore" :class="child.isOpen?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
                    </div>
                    <ul v-show="child.isOpen">
                        <li v-for="subChild in child.children" :key="subChild.id" class="subsubmenu-item" :class="!subChild.isMore && subChild.id != currentId?'menuHover':''">
                            <div class="subsubmenu-header" @click.stop="toggleMenu(subChild)" @click="toPage(subChild)" :class="subChild.id == currentId && !subChild.isMore?'menuChecked':''">
                                <span>{{ subChild.name }}</span>
                                <i v-if="subChild.isMore" :class="subChild.isOpen?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
                            </div>
                            <ul v-show="subChild.isOpen">
                                <li v-for="subsubChild in subChild.children" :key="subsubChild.id" class="subsubmenu-item" :class="!subsubChild.isMore && subsubChild.id != currentId?'menuHover':''">
                                    <div class="subsubmenu-header" @click.stop="toggleMenu(subsubChild)" @click="toPage(subsubChild)" :class="subsubChild.id == currentId && !subsubChild.isMore?'menuChecked':''">
                                        <span>{{ subsubChild.name }}</span>
                                        <!-- <i v-if="subsubChild.isMore" :class="subsubChild.isOpen?'el-icon-arrow-down':'el-icon-arrow-right'"></i> -->
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      menuItems: [
        {
          id: '1',
          name: 'API文档简介',
          isMore: true,
          isOpen: true,
          children: [
            {
              id: '1-1',
              name: 'API文档简介',
              link: '/introduction1',
              isMore: false,
              isOpen: false
            }
          ]
        },
        {
          id: '2',
          name: '前言',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '2-1',
              name: '认证',
              link: '/introduction1',
              isMore: false,
              isOpen: false
            },
            {
              id: '2-2',
              name: '错误',
              link: '/introduction2',
              isMore: false,
              isOpen: false
            },
            // {
            //   id: '2-3',
            //   name: '分页',
            //   link: '/introduction3',
            //   isMore: false,
            //   isOpen: false
            // },
            {
              id: '2-4',
              name: '参数说明',
              link: '/introduction4',
              isMore: false,
              isOpen: false
            },
            // {
            //   id: '2-5',
            //   name: '元数据',
            //   link: '/introduction5',
            //   isMore: false,
            //   isOpen: false
            // }
          ]
        },
        {
          id: '3',
          name: '基础交易',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '3-1',
              name: 'Charges支付',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '3-1-1',
                  name: 'Charges支付概述',
                  isMore: false,
                  isOpen: false,
                  link: '/paySurvey'
                },
                {
                  id: '3-1-2',
                  name: '创建Charge对象',
                  isMore: false,
                  isOpen: false,
                  link: '/payCreate'
                },
                {
                  id: '3-1-3',
                  name: '撤销Charge对象',
                  isMore: false,
                  isOpen: false,
                  link: '/payCancel'
                },
                {
                  id: '3-1-4',
                  name: '查询Charge对象',
                  isMore: false,
                  isOpen: false,
                  link: '/payQuery'
                },
                {
                  id: '3-1-5',
                  name: '查询Charge对象列表',
                  isMore: false,
                  isOpen: false,
                  link: '/payQueryList'
                },
                // {
                //     id:"3-1-6",
                //     name: 'Charge相关的Event类型',
                //     isMore: false,
                //     isOpen:false,
                //     link:'/payEvent'
                // },
                // {
                //   id: '3-1-7',
                //   name: '确认支付对象',
                //   isMore: false,
                //   isOpen: false,
                //   link: '/payAffirm'
                // }
                {
                  id: '3-1-8',
                  name: '关单状态查询',
                  isMore: false,
                  isOpen: false,
                  link: '/payWaivePayment'
                },
              ]
            },
            {
              id: '3-2',
              name: 'Refunds退款',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '3-2-1',
                  name: 'Refunds退款概述',
                  link: '/refundSurvey',
                  isMore: false,
                  isOpen: false
                },
                {
                  id: '3-2-2',
                  name: '创建Refund对象',
                  link: '/refundCreate',
                  isMore: false,
                  isOpen: false
                },
                {
                  id: '3-2-3',
                  name: '查询Refund对象',
                  link: '/refundQuery',
                  isMore: false,
                  isOpen: false
                }
                // {
                //     id:"3-2-4",
                //     name: '查询Refund对象列表',
                //     link:'/refundQueryList',
                //     isMore: false,
                //     isOpen:false,
                // },
                // {
                //     id:"3-2-5",
                //     name: 'Refund相关的Event类型',
                //     link:'/refundEvent',
                //     isMore: false,
                //     isOpen:false,
                // }
              ]
            }
            // {
            //     id:'3-3',
            //     name: 'Batch Refunds批量退款',
            //     link: '',
            //     isMore: true,
            //     isOpen:false,
            //     children: [
            //         {
            //             id:"3-3-1",
            //             name: 'Batch Refunds 批量退款概述',
            //             link:'/batchRefundSurvey',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-3-2",
            //             name: '创建Batch Refund对象',
            //             link:'/batchRefundCreate',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-3-3",
            //             name: '查询Batch Refund对象',
            //             link:'/batchRefundQuery',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-3-4",
            //             name: '查询Batch Refund对象列表',
            //             link:'/batchRefundQueryList',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-3-5",
            //             name: 'Batch Refund相关的Event类型',
            //             link:'/batchRefundEvent',
            //             isMore: false,
            //             isOpen:false,
            //         }
            //     ]
            // },
            // {
            //     id:'3-4',
            //     name: 'Transfers企业付款',
            //     link: '',
            //     isMore: true,
            //     isOpen:false,
            //     children: [
            //         {
            //             id:"3-4-1",
            //             name: 'Transfers 企业付款概述',
            //             link:'/businessPaySurvey',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-4-2",
            //             name: '创建Transfer对象',
            //             link:'/businessPayCreate',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-4-3",
            //             name: '查询Transfer对象',
            //             link:'/businessPayQuery',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-4-4",
            //             name: '查询Transfer对象列表',
            //             link:'/businessPayQueryList',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-4-5",
            //             name: 'Transfer相关的Event类型',
            //             link:'/businessPayEvent',
            //             isMore: false,
            //             isOpen:false,
            //         }
            //     ]
            // },
            // {
            //     id:'3-5',
            //     name: 'Batch Transfers 批量企业付款',
            //     link: '',
            //     isMore: true,
            //     isOpen:false,
            //     children: [
            //         {
            //             id:"3-5-1",
            //             name: 'Batch Transfers 批量企业付款概述',
            //             link:'/batchBusinessPaySurvey',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-5-2",
            //             name: '创建Batch Transfer对象',
            //             link:'/batchBusinessPayCreate',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-5-3",
            //             name: '查询Batch Transfer对象',
            //             link:'/batchBusinessPayQuery',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-5-4",
            //             name: '查询Batch Transfer对象列表',
            //             link:'/batchBusinessPayQueryList',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-5-5",
            //             name: 'Batch Transfers相关的Event类型',
            //             link:'/batchBusinessPayEvent',
            //             isMore: false,
            //             isOpen:false,
            //         }
            //     ]
            // },
            // {
            //     id:'3-6',
            //     name: 'Red Envelopes红包',
            //     link: '',
            //     isMore: true,
            //     isOpen:false,
            //     children: [
            //         {
            //             id:"3-6-1",
            //             name: 'Red Envelopes红包概述',
            //             link:'/redEnvelopesSurvey',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-6-2",
            //             name: '创建Red Envelope对象',
            //             link:'/redEnvelopesCreate',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-6-3",
            //             name: '查询Red Envelope对象',
            //             link:'/redEnvelopesQuery',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-6-4",
            //             name: '查询Red Envelope对象列表',
            //             link:'/redEnvelopesQueryList',
            //             isMore: false,
            //             isOpen:false,
            //         },
            //         {
            //             id:"3-6-5",
            //             name: 'Red envelope相关的Event类型',
            //             link:'/redEnvelopesEvent',
            //             isMore: false,
            //             isOpen:false,
            //         }
            //     ]
            // }
          ]
        },
        {
          id: '4',
          name: '会员账户系统',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '4-1',
              name: '用户',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '4-1-1',
                  name: 'Users用户',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-1-1-1',
                      name: 'Users用户概述',
                      link: '/usersSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-1-1-2',
                      name: '创建User对象',
                      link: '/usersCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-1-1-3',
                      name: '查询User对象',
                      link: '/usersQuery',
                      isMore: false,
                      isOpen: false
                    }
                    // {
                    //     id:"4-1-1-4",
                    //     name: '更新User对象',
                    //     link:'/usersUpdate',
                    //     isMore: false,
                    //     isOpen:false,
                    // },
                    // {
                    //     id:"4-1-1-5",
                    //     name: '查询User对象列表',
                    //     link:'/usersQueryList',
                    //     isMore: false,
                    //     isOpen:false,
                    // }
                  ]
                },
                {
                  id: '4-1-2',
                  name: 'Settle Accounts 用户结算账户',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-1-2-1',
                      name: 'Settle Accounts用户结算账户概述',
                      link: '/settleAccountsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-1-2-2',
                      name: '创建Settle Account对象',
                      link: '/settleAccountsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-1-2-3',
                      name: '查询Settle Account对象',
                      link: '/settleAccountsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-1-2-4',
                      name: '删除Settle Account对象',
                      link: '/settleAccountsDel',
                      isMore: false,
                      isOpen: false
                    }
                    // {
                    //     id:"4-1-2-5",
                    //     name: '查询Settle Account对象列表',
                    //     link:'/settleAccountsQueryList',
                    //     isMore: false,
                    //     isOpen:false,
                    // }
                  ]
                }
              ]
            },
            {
              id: '4-2',
              name: '订单',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '4-2-1',
                  name: 'Orders订单',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-2-1-1',
                      name: 'Orders订单概述',
                      link: '/ordersSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-2',
                      name: '创建Order对象',
                      link: '/ordersCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-3',
                      name: '支付Order对象',
                      link: '/ordersPay',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-4',
                      name: '取消&更新Order对象',
                      link: '/ordersCancelOrUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-5',
                      name: '查询Order对象',
                      link: '/ordersQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-6',
                      name: '查询Order对象列表',
                      link: '/ordersQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-7',
                      name: '查询Order中的Charge对象',
                      link: '/ordersQueryObj',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-8',
                      name: '查询Order中的Charge对象列表',
                      link: '/ordersQueryObjList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-1-9',
                      name: 'Order对象相关的事件类型',
                      link: '/ordersEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-2-2',
                  name: '订单Refunds退款',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-2-2-1',
                      name: '订单Refunds退款概述',
                      link: '/ordersRefundSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-2-2',
                      name: '创建订单Refund对象',
                      link: '/ordersRefundCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-2-3',
                      name: '查询订单Refund对象',
                      link: '/ordersRefundQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-2-4',
                      name: '查询订单Redund对象列表',
                      link: '/ordersRefundQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-2-2-5',
                      name: 'Refund对象相关的事件类型',
                      link: '/ordersRefundEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            },
            {
              id: '4-3',
              name: '余额',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '4-3-1',
                  name: 'Recharges充值',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-1-1',
                      name: 'Recharges充值概述',
                      link: '/rechargesSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-1-2',
                      name: '创建Recharge对象',
                      link: '/rechargesCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-1-3',
                      name: '查询Recharge对象',
                      link: '/rechargesQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-1-4',
                      name: '查询Recharge对象列表',
                      link: '/rechargesQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-1-5',
                      name: 'Recharge相关的Event类型',
                      link: '/rechargesEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-2',
                  name: '充值Refunds退款',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-2-1',
                      name: '充值Refunds退款概述',
                      link: '/rechargesRefundsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-2-2',
                      name: '创建充值Refund对象',
                      link: '/rechargesRefundsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-2-3',
                      name: '查询充值Refund对象',
                      link: '/rechargesRefundsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-2-4',
                      name: '查询充值Refund对象列表',
                      link: '/rechargesRefundsQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-2-5',
                      name: '充值Refund相关的Event类型',
                      link: '/rechargesRefundsEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-3',
                  name: 'Withdrawals提现',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-3-1',
                      name: 'Withdrawals提现概述',
                      link: '/withdrawalsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-3-2',
                      name: '创建Withdrawal对象',
                      link: '/withdrawalsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-3-3',
                      name: '更新Withdrawal对象',
                      link: '/withdrawalsUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-3-4',
                      name: '查询Withdrawal对象',
                      link: '/withdrawalsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-3-5',
                      name: '查询Withdrawal对象列表',
                      link: '/withdrawalsQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-3-6',
                      name: 'Withdrawal相关的Event类型',
                      link: '/withdrawalsEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-4',
                  name: 'Batch Withdrawals批量提现',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-4-1',
                      name: 'Batch Withdrawals批量提现',
                      link: '/batchWithdrawalsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-4-2',
                      name: '创建Batch Withdrawal对象',
                      link: '/batchWithdrawalsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-4-3',
                      name: '查询Batch Withdrawal对象',
                      link: '/batchWithdrawalsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-4-4',
                      name: '查询Batch Withdrawal对象列表',
                      link: '/batchWithdrawalsQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-4-5',
                      name: 'Batch Withdrawal对象相关的Event类型',
                      link: '/batchWithdrawalsEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-5',
                  name: 'Balance Bonuses余额赠送',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-5-1',
                      name: 'Balance Bonuses余额赠送概述',
                      link: '/balanceBonusesSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-5-2',
                      name: '创建Balance Bonus对象',
                      link: '/balanceBonusesCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-5-3',
                      name: '查询Balance Bonus对象',
                      link: '/balanceBonusesQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-5-4',
                      name: '查询Balance Bonus对象列表',
                      link: '/balanceBonusesQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-6',
                  name: 'Balance Transfers余额转账',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-6-1',
                      name: 'Balance Bonuses余额转账概述',
                      link: '/balanceTransfersSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-6-2',
                      name: '创建Balance Transfer对象',
                      link: '/balanceTransfersCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-6-3',
                      name: '查询Balance Transfer对象',
                      link: '/balanceTransfersQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-6-4',
                      name: '查询Balance Transfer对象列表',
                      link: '/balanceTransfersQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-7',
                  name: 'Balance Settlements余额结算',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-7-1',
                      name: 'Balance Settlements余额结算概述',
                      link: '/balanceSettlementsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-7-2',
                      name: '查询Balance Settlements对象',
                      link: '/balanceSettlementsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-7-3',
                      name: '查询Balance Settlements对象列表',
                      link: '/balanceSettlementsQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-3-8',
                  name: 'Balance Transactions余额明细',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-3-8-1',
                      name: 'Balance Transaction余额明细概述',
                      link: '/balanceTransactionsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-8-2',
                      name: '查询Balance Transaction对象',
                      link: '/balanceTransactionsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-3-8-3',
                      name: '查询Balance Transaction对象列表',
                      link: '/balanceTransactionsQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            },
            {
              id: '4-4',
              name: '优惠券',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '4-4-1',
                  name: 'Coupon Templates优惠券模板',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-4-1-1',
                      name: 'Coupon Templates优惠券模板概述',
                      link: '/couponTemplatesSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-1-2',
                      name: '创建Coupon Template对象',
                      link: '/couponTemplatesCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-1-3',
                      name: '查询Coupon Template对象',
                      link: '/couponTemplatesQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-1-4',
                      name: '查询Coupon Template对象列表',
                      link: '/couponTemplatesQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-1-5',
                      name: '更新Coupon Template对象',
                      link: '/couponTemplatesUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-1-6',
                      name: '删除Coupon Template对象',
                      link: '/couponTemplatesDel',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '4-4-2',
                  name: 'Coupons优惠券',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '4-4-2-1',
                      name: 'Coupons优惠券概述',
                      link: '/couponSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-2',
                      name: '创建Coupon对象',
                      link: '/couponCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-3',
                      name: '批量创建Coupon对象',
                      link: '/batchCouponCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-4',
                      name: '查询Coupon对象',
                      link: '/couponQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-5',
                      name: '查询用户的Coupon对象列表',
                      link: '/couponUserQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-6',
                      name: '查询Coupon对象列表',
                      link: '/couponQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-7',
                      name: '更新Coupon对象',
                      link: '/couponUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '4-4-2-8',
                      name: '删除Coupon对象',
                      link: '/couponDel',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: '5',
          name: '多级商户系统',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '5-1',
              name: '用户',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '5-1-1',
                  name: 'Users用户',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-1-1-1',
                      name: 'Users用户概述',
                      link: '/usersSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-1-2',
                      name: '创建User对象',
                      link: '/usersCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-1-3',
                      name: '查询User对象',
                      link: '/usersQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-1-4',
                      name: '更新User对象',
                      link: '/usersUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-1-5',
                      name: '查询User对象列表',
                      link: '/usersQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-1-2',
                  name: 'Settle Accounts 用户结算账户',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-1-2-1',
                      name: 'Settle Accounts 用户结算账户概述',
                      link: '/settleAccountsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-2-2',
                      name: '创建Settle Account对象',
                      link: '/settleAccountsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-2-3',
                      name: '查询Settle Account对象',
                      link: '/settleAccountsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-2-4',
                      name: '删除Settle Account对象',
                      link: '/settleAccountsDel',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-1-2-5',
                      name: '查询Settle Account对象列表',
                      link: '/settleAccountsQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            },
            {
              id: '5-2',
              name: '商户层级',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '5-2-1',
                  name: 'Sub Apps子商户应用',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-2-1-1',
                      name: 'Sub Apps子商户应用概述',
                      link: '/subAppsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-1-2',
                      name: '创建Sub Apps对象',
                      link: '/subAppsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-1-3',
                      name: '查询Sub Apps对象',
                      link: '/subAppsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-1-4',
                      name: '更新Sub Apps对象',
                      link: '/subAppsUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-1-5',
                      name: '删除Sub Apps对象',
                      link: '/subAppsDel',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-1-6',
                      name: '查询Sub Apps对象列表',
                      link: '/subAppsQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-2-2',
                  name: 'Channels子商户渠道参数',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-2-2-1',
                      name: 'Channels子商户渠道参数概述',
                      link: '/channelsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-2-2',
                      name: '创建Channels对象',
                      link: '/channelsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-2-3',
                      name: '查询Channels对象',
                      link: '/channelsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-2-4',
                      name: '更新Channels对象',
                      link: '/channelsUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-2-2-5',
                      name: '删除Channels对象',
                      link: '/channelsDel',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            },
            {
              id: '5-3',
              name: '订单',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '5-3-1',
                  name: 'Orders订单',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-3-1-1',
                      name: 'Orders订单概述',
                      link: '/ordersSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-2',
                      name: '创建Order对象',
                      link: '/ordersCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-3',
                      name: '支付Order对象',
                      link: '/ordersPay',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-4',
                      name: '取消&更新Order对象',
                      link: '/ordersCancelOrUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-5',
                      name: '查询Order对象',
                      link: '/ordersQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-6',
                      name: '查询Order对象列表',
                      link: '/ordersQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-7',
                      name: '查询Order中的Charge对象',
                      link: '/ordersQueryObj',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-8',
                      name: '查询Order中的Charge对象列表',
                      link: '/ordersQueryObjList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-1-9',
                      name: 'Order对象相关的事件类型',
                      link: '/ordersEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-3-2',
                  name: '订单Refunds退款',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-3-2-1',
                      name: '订单Refunds退款概述',
                      link: '/ordersRefundSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-2-2',
                      name: '创建订单Refund对象',
                      link: '/ordersRefundCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-2-3',
                      name: '查询订单Refund对象',
                      link: '/ordersRefundQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-2-4',
                      name: '查询订单Redund对象列表',
                      link: '/ordersRefundQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-3-2-5',
                      name: 'Refund对象相关的事件类型',
                      link: '/ordersRefundEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            },
            {
              id: '5-4',
              name: '分润',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '5-4-1',
                  name: 'Royalties分润',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-4-1-1',
                      name: 'Royalty分润概述',
                      link: '/royaltySurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-1-2',
                      name: '批量更新Royalty对象',
                      link: '/royaltyBatchUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-1-3',
                      name: '查询Royalty对象',
                      link: '/royaltyQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-1-4',
                      name: '查询Royalty对象列表',
                      link: '/royaltyQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-4-2',
                  name: 'Royalty Templates分润模板',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-4-2-1',
                      name: 'Royalty Templates分润模板概述',
                      link: '/royaltyTemplatesSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-2-2',
                      name: '创建Royalty Templates对象',
                      link: '/royaltyTemplatesCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-2-3',
                      name: '查询Royalty Templates对象',
                      link: '/royaltyTemplatesQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-2-4',
                      name: '查询Royalty Templates对象列表',
                      link: '/royaltyTemplatesQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-2-5',
                      name: '更新Royalty Templates对象',
                      link: '/royaltyTemplatesUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-2-6',
                      name: '删除Royalty Templates对象',
                      link: '/royaltyTemplatesDel',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-4-3',
                  name: 'Royalty Settlements分润结算',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-4-3-1',
                      name: 'Royalty Settlements分润结算概述',
                      link: '/royaltySettlementsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-3-2',
                      name: '创建Royalty Settlement对象',
                      link: '/royaltySettlementsCreate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-3-3',
                      name: '查询Royalty Settlement对象',
                      link: '/royaltySettlementsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-3-4',
                      name: '更新Royalty Settlement对象',
                      link: '/royaltySettlementsUpdate',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-3-5',
                      name: '查询Royalty Settlement对象列表',
                      link: '/royaltySettlementsQueryList',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                },
                {
                  id: '5-4-4',
                  name: 'Royalty Transactions分润结算明细',
                  link: '',
                  isMore: true,
                  isOpen: false,
                  children: [
                    {
                      id: '5-4-4-1',
                      name: 'Royalty Transactions分润结算明细概况',
                      link: '/royaltyTransactionsSurvey',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-4-2',
                      name: '查询Royalty Transactions对象',
                      link: '/royaltyTransactionsQuery',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-4-3',
                      name: '查询Royalty Transactions对象列表',
                      link: '/royaltyTransactionsQueryList',
                      isMore: false,
                      isOpen: false
                    },
                    {
                      id: '5-4-4-4',
                      name: 'Royalty Transactions相关的Event类型',
                      link: '/royaltyTransactionsEvent',
                      isMore: false,
                      isOpen: false
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: '6',
          name: '辅助接口',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '6-1',
              name: '身份证银行卡信息认证接口',
              link: '',
              isMore: true,
              isOpen: false,
              children: [
                {
                  id: '6-1-1',
                  name: '身份证银行卡信息认证接口概述',
                  link: '/cardSurvey',
                  isMore: false,
                  isOpen: false
                },
                {
                  id: '6-1-2',
                  name: '请求认证接口',
                  link: '/cardAuth',
                  isMore: false,
                  isOpen: false
                }
              ]
            }
          ]
        },
        {
          id: '7',
          name: 'Webhooks回调',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '7-1',
              name: 'Webhooks回调概述',
              link: '/webhooksSurvey',
              isMore: false,
              isOpen: false
            },
            {
              id: '7-2',
              name: 'Event事件类型',
              link: '/webhooksEvent',
              isMore: false,
              isOpen: false
            },
            {
              id: '7-3',
              name: '查询Event对象',
              link: '/webhooksEventQuery',
              isMore: false,
              isOpen: false
            }
          ]
        },
        {
          id: '8',
          name: '附录',
          isMore: true,
          isOpen: false,
          children: [
            {
              id: '8-1',
              name: '支付渠道属性值',
              link: '/appendix1',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-2',
              name: '支付渠道extra参数说明',
              link: '/appendix2',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-3',
              name: '子商户应用渠道参数说明',
              link: '/appendix3',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-4',
              name: '微信企业付款银行编号列表',
              link: '/appendix4',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-5',
              name: '通联代付银行编号说明',
              link: '/appendix5',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-6',
              name: '通联代付业务代码说明',
              link: '/appendix6',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-7',
              name: '银联电子代付银行编号说明',
              link: '/appendix7',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-8',
              name: '易宝支付商品类型码',
              link: '/appendix8',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-9',
              name: '易宝支付用户标识类型码',
              link: '/appendix9',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-10',
              name: '认证接口result_code说明',
              link: '/appendix10',
              isMore: false,
              isOpen: false
            },
            {
              id: '8-11',
              name: '跨境渠道currency说明',
              link: '/appendix11',
              isMore: false,
              isOpen: false
            }
          ]
        }
        // {
        //     id:'9',
        //     name: 'API更新日志',
        //     isMore: true,
        //     isOpen:false,
        //     children: [
        //         {
        //             id:'9-1',
        //             name: 'API更新日志',
        //             link: '/apiLog',
        //             isMore: false,
        //             isOpen:false
        //         }
        //     ]
        // }
      ],
      currentId: '1-1'
    }
  },
  components: {},
  methods: {
    toggleMenu (child) {
      if (child.isMore) {
        child.isOpen = !child.isOpen
      }
      if (!child.isMore && !child.isOpen) {
        this.currentId = child.id
        sessionStorage.setItem('menuState', JSON.stringify(this.menuItems))
        sessionStorage.setItem('currentId', this.currentId)
      }
    },
    toPage (item) {
      if (item.link != '' && this.$route.path !== item.link) {
        this.$router.push(item.link)
      }
    }
  },
  created () {
    const savedState = sessionStorage.getItem('menuState')
    const _currentId = sessionStorage.getItem('currentId')
    if (_currentId) {
      this.currentId = _currentId
    }
    if (savedState) {
      this.menuItems = JSON.parse(savedState)
    }
  }
}
</script>

<style scoped lang="less">
.menuHover{
    &:hover{
        background-color: rgb(237,237,237);
    }
}
.menuChecked{
    background-color: rgb(53,200,230);
    color: #fff;
}
.sidebar {
  width: 250px;
  height: 100vh;
  background-color: rgb(250,250,250);
  font-size: 12px;
  font-weight: 400;
  overflow-y: auto;
  flex-shrink: 0;

  .menu{
    padding: 0;

    .menu-item{
        list-style: none;
        padding: 5px 0;

        .menu-header{
            cursor: pointer;
            padding: 5px 10px;
            margin: 5px 0;
            display: flex;
            justify-content: space-between;
        }

        ul{
            padding-left: 15px;

            .submenu-item{
                list-style: none;
                padding: 5px 0;

                .submenu-header{
                    cursor: pointer;
                    padding: 5px 10px;
                    margin: 5px 0;
                    display: flex;
                    justify-content: space-between;
                }

                ul{
                    padding-left: 20px;

                    .subsubmenu-item{
                        list-style: none;
                        padding: 5px 0;

                        .subsubmenu-header{
                            cursor: pointer;
                            padding: 5px 10px;
                            margin: 5px 0;
                            display: flex;
                            justify-content: space-between;
                        }
                    }
                }
            }
        }
    }
  }
}
</style>
